export default __webpack_public_path__ + "static/media/deck_lg.480719ef.jpg";